module.exports = __webpack_public_path__ + "media/img/marquee/marquee-plugins-b73a59003ca1a452a7c89620e47079b8.jpg";